export default __webpack_public_path__ + "static/media/04.34f673bc.png";